jQuery(function () {
    jQuery('.recipe-book-slick').slick({
        slidesToShow: 3.2,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: true,
        autoplay: false,
        speed: 500,
        responsive: [
        {
            breakpoint: 1024,
            settings: { slidesToShow: 2 },
        },
        {
            breakpoint: 750,
            settings: { slidesToShow: 1.2, arrows: false },
        },
        ],
    });
});


document.addEventListener("DOMContentLoaded", function () {

  const popup = document.getElementById('recipe-popup');
  const btn = document.querySelector('.download-recipe-btn');
  const closeBtns = document.querySelectorAll('.close-popup');
  const form = document.getElementById('recipe-form');
  const errorMsg = document.getElementById('error-msg');
  const phoneInput = document.getElementById('phone');

  const PDF_URL = "https://cdn.shopify.com/s/files/1/0936/2469/7202/files/Clinical_Indian_Dessert_Recipes_Using_Zeroh.pdf?v=1768545496";
  const API_URL = "https://script.google.com/macros/s/AKfycbxYHflbaPbLNaUdvadoYggQMQcXICDTI0kUPyLea2Tae8U983O9ZDl_McAJkL3MRwoG/exec";

  // 🔓 Open popup
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  });

  // ❌ Close popup
  function closePopup() {
    popup.style.display = 'none';
    document.body.style.overflow = 'auto';
  }

  closeBtns.forEach(btn => {
    btn.addEventListener('click', closePopup);
  });

  // Close on outside click
  window.addEventListener('click', function (e) {
    if (e.target === popup) {
      closePopup();
    }
  });

  // 📱 Phone input restriction (only numbers + max 10 digits)
  phoneInput.addEventListener('input', function () {
    let value = this.value.replace(/[^0-9]/g, '');
    if (value.length > 10) {
      value = value.slice(0, 10);
    }
    this.value = value;
  });

  // ✅ Validation functions
  function validatePhone(phone) {
    return /^[6-9][0-9]{9}$/.test(phone);
  }

  function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
}

  // 🚀 Form submit
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    let name = document.getElementById('name').value.trim();
    let email = document.getElementById('email').value.trim();
    let phone = phoneInput.value.trim();

    errorMsg.style.display = "none";

    // 🔴 Required fields
    if (!name || !email || !phone) {
      errorMsg.innerText = "Please fill all fields";
      errorMsg.style.display = "block";
      return;
    }

    // 🔴 Email validation (Gmail only)
    if (!validateEmail(email)) {
  errorMsg.innerText = "Enter a valid email address";
  errorMsg.style.display = "block";
  return;
}

    // 🔴 Phone length check
    if (phone.length !== 10) {
      errorMsg.innerText = "Phone number must be exactly 10 digits";
      errorMsg.style.display = "block";
      return;
    }

    // 🔴 Phone format check
    if (!validatePhone(phone)) {
      errorMsg.innerText = "Phone must start with 6-9";
      errorMsg.style.display = "block";
      return;
    }

    // 📡 Send data to Google Sheets
    fetch(API_URL, {
  method: "POST",
  mode: "no-cors", // ✅ IMPORTANT
  body: JSON.stringify({ name, email, phone })
})
.then(() => {
  // Because no-cors doesn't return response
  window.open(PDF_URL, "_blank");
  closePopup();
  form.reset();
})
.catch(() => {
  errorMsg.innerText = "Something went wrong. Try again.";
  errorMsg.style.display = "block";
});

  });

});